<template>
  <section class="head-nav-bar-container" :class="lang">
    <img class="logo" src="../../assets/pc/xswap.png" @click="toHome" />
    <div class="head-nav">
      <ul class="title-container" :class="lang">
        <li
          class="title-item-container flex-center"
          v-for="(item, index) in homeLang.head"
          @click.stop="clickEvent(index, item.url)"
          :key="index"
        >
          <img
            class="mint"
            src="../../assets/pc/header/mint.gif"
            v-if="item.title === 'NFT'"
          />
          <span :class="{ 'head-title-active': status[index]['active'] }">{{
            item.title
          }}</span>
          <img
            class="slide"
            src="../../assets/pc/header/slide.png"
            v-show="!item.url && !status[index]['active']"
          />
          <img
            class="slide"
            src="../../assets/pc/header/slide_active.png"
            v-show="!item.url && status[index]['active']"
          />
          <ul
            class="slide-content-container"
            v-if="status[index]['active']"
            @click.stop="status[index]['active'] = true"
          >
            <li v-for="item1 in item['list']" :key="item1.url">
              <div @click="innerClickTo(item1.type, item1.url)">
                <p class="title">
                  <span>{{ item1.title }}</span>
                  <!--                  <span class="soon" v-if="item1.soon">{{ item1.soon }}</span>-->
                </p>
                <p class="desc">{{ item1.desc }}</p>
                <div class="line"></div>
                <div
                  class="icon pic-full"
                  :class="{ 'fix-icon': !item1.desc }"
                ></div>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div
      class="launch-app flex-center"
      @click="toUrl('open', homeLang.head[0].url)"
    >
      {{ homeLang.launchApp }}
    </div>
  </section>
</template>

<script>
export default {
  name: "HeadNavBar",
  props: {
    homeLang: {
      type: Object,
    },
  },
  data() {
    return {
      status: [
        {
          active: false,
        },
        {
          active: false,
        },
        {
          active: false,
        },
        {
          active: false,
        },
        {
          active: false,
        },
        {
          active: false,
        },
      ],
    };
  },
  mounted() {
    document.body.addEventListener("click", () => {
      this.activeReset();
    });
  },
  methods: {
    activeReset() {
      for (let item of this.status) {
        item.active = false;
      }
    },
    clickEvent(index, url) {
      if (url) {
        this.toUrl("open", url);
      } else {
        const isActive = this.status[index]["active"];
        this.activeReset();
        this.status[index]["active"] = !isActive;
      }
    },
    innerClickTo(type, url) {
      if (url === "#") return false;
      if (type === "route") {
        this.$router.push(url);
      } else {
        this.toUrl("open", url);
      }
    },
    toHome() {
      this.$router.push("/" + this.lang + "/");
    },
  },
};
</script>

<style lang="less">
.head-nav-bar-container {
  height: 0.6rem;
  margin: 0 auto;
  z-index: 99;
  position: relative;

  &.zh {
    width: 10rem;
  }

  &.en {
    width: 11.5rem;
  }

  .logo {
    float: left;
    cursor: pointer;
    // width: 1.1rem;
    height: 0.36rem;
    margin-top: 0.24rem;
  }

  .head-nav {
    height: 100%;
    float: left;
    .title-container {
      height: 100%;
      .title-item-container {
        position: relative;
        // width: 1.44rem;
        font-size: 0.18rem;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #333333;
        float: left;
        margin-top: 0.29rem;
        height: 0.28rem;
        cursor: pointer;
        // &:first-child {
        //   margin-left: 0.12rem;
        // }
        margin-left: 0.3rem;
        .mint {
          width: 20px;
        }
        .head-title-active {
          color: #2761e7;
        }
        .slide {
          width: 0.09rem;
          margin-left: 0.08rem;
          -webkit-transform: translateY(0.01rem); //chrome
          -moz-transform: translateY(0); //firefox
          -ms-transform: translateY(0); //IE
          -o-transform: translateY(0);
        }
        .slide-content-container {
          position: absolute;
          top: 0.43rem;
          right: -0.3rem;
          width: 3.55rem;
          border-radius: 0.1rem;
          background-color: white;
          opacity: 0.98;
          // &::after {
          //   display: block;
          //   content: '';
          //   width: 0;
          //   height: 0;
          //   border-width: 0.1rem;
          //   border-color: transparent transparent white transparent;
          //   border-style: solid;
          //   position: absolute;
          //   top: -0.2rem;
          //   right: 0.5rem;
          // }
          &::before {
            position: absolute;
            display: block;
            content: "";
            z-index: -79;
          }
          li {
            position: relative;
            padding: 0.26rem 0.29rem 0.15rem 0.77rem;
            .title {
              font-size: 0.14rem;
              font-family: PingFangSC, PingFangSC-Medium;
              font-weight: 500;
              color: #333333;
              line-height: 0.22rem;

              .soon {
                background-color: #f1f1f1;
                border-radius: 0.12rem;
                margin-left: 0.11rem;
                font-size: 0.11rem;
                padding: 0.04rem 0.13rem;
                font-family: PingFangSC, PingFangSC-Medium;
                color: #999999;
              }
            }
            .desc {
              margin-top: 0.03rem;
              font-size: 0.12rem;
              font-family: PingFangSC, PingFangSC-Regular;
              color: #999999;
              line-height: 0.2rem;
            }
            .line {
              position: absolute;
              height: 1px;
              left: 0.28rem;
              width: 2.97rem;
              bottom: 0;
              background: #f2f2f2;
            }
            &:last-child {
              .line {
                display: none;
              }
            }
            .icon {
              position: absolute;
              width: 0.34rem;
              height: 0.34rem;
              left: 0.29rem;
              top: 0.28rem;
            }
            .fix-icon {
              transform: translateY(-0.08rem);
            }
            &:hover {
              .title {
                color: #2761e7;
              }
              .desc {
                color: #7693d8;
              }
            }
          }
        }
        &:nth-of-type(2) {
          .slide-content-container li {
            &:nth-of-type(1) {
              .icon {
                background-image: url("../../assets/pc/header/nft_design.png");
              }
              &:hover .icon {
                background-image: url("../../assets/pc/header/nft_design_active.png");
              }
            }
            &:nth-of-type(2) {
              .icon {
                background-image: url("../../assets/pc/header/transit_nft.png");
              }
              &:hover .icon {
                background-image: url("../../assets/pc/header/transit_nft_active.png");
              }
            }
            &:nth-of-type(3) {
              .icon {
                background-image: url("../../assets/pc/header/NFT_Marketplace.png");
              }
              &:hover .icon {
                background-image: url("../../assets/pc/header/NFT_Marketplace_active.png");
              }
            }
          }
        }
        // &:nth-of-type(3) {
        //   width: 1.6rem;
        // }
        &:nth-of-type(4) {
          .slide-content-container li {
            &:nth-of-type(1) {
              .icon {
                background-image: url("../../assets/pc/header/dao.png");
              }
              &:hover .icon {
                background-image: url("../../assets/pc/header/dao_active.png");
              }
            }
            &:nth-of-type(2) {
              .icon {
                background-image: url("../../assets/pc/header/donate.png");
              }
              &:hover .icon {
                background-image: url("../../assets/pc/header/donate_active.png");
              }
            }
            &:nth-of-type(3) {
              .icon {
                background-image: url("../../assets/pc/header/fee.png");
              }
              &:hover .icon {
                background-image: url("../../assets/pc/header/fee_active.png");
              }
            }
          }
        }
        &:nth-of-type(5) {
          .slide-content-container li {
            &:nth-of-type(1) {
              .icon {
                background-image: url("../../assets/pc/header/community.png");
              }
              &:hover .icon {
                background-image: url("../../assets/pc/header/community_active.png");
              }
            }
            &:nth-of-type(2) {
              .icon {
                background-image: url("../../assets/pc/header/twitter.png");
              }
              &:hover .icon {
                background-image: url("../../assets/pc/header/twitter_active.png");
              }
            }
            &:nth-of-type(3) {
              .icon {
                background-image: url("../../assets/pc/header/docs.png");
              }
              &:hover .icon {
                background-image: url("../../assets/pc/header/docs_active.png");
              }
            }
          }
        }
        &:nth-of-type(6) {
          .slide-content-container li {
            &:nth-of-type(1) {
              .icon {
                background-image: url("../../assets/pc/header/ramp.png");
              }
              &:hover .icon {
                background-image: url("../../assets/pc/header/ramp_active.png");
              }
            }
            &:nth-of-type(2) {
              .icon {
                background-image: url("../../assets/pc/header/transit.png");
              }
              &:hover .icon {
                background-image: url("../../assets/pc/header/transit_active.png");
              }
            }
          }
        }
      }
      &.en {
        .title-item-container {
          &:nth-of-type(1) {
            width: 1rem !important;
          }
        }
      }
      // &.zh {
      //   .title-item-container {
      //     &:nth-of-type(1) {
      //       width: 0.7rem !important;
      //     }
      //     &:nth-of-type(5) {
      //       width: 0.7rem !important;
      //     }
      //   }
      // }
    }
  }
  .launch-app {
    cursor: pointer;
    float: right;
    margin-top: 0.2rem;
    padding: 0 0.3rem;
    height: 0.44rem;
    border: 1px solid #999999;
    border-radius: 0.23rem;
    font-size: 0.16rem;
    font-family: PingFangSC, PingFangSC-Regular;
    color: #333333;
  }
}
</style>
